import React, { act, use, useEffect, useMemo } from "react";
import { formatDate } from "../utils/commonFunctions";
import { COLOR_PALETTE } from "../utils/constants";
import {EmployeeCardManagerView}  from "./EmployeeCard";
import { NotificationCenter } from "./NotificationComponents";
import { useNavigate } from "react-router";
import { EmployeeSignIns, EventData } from "./Shared/Types";
import { getEmployeesForManager, getSignInsForManagerOnDate, fetchEmployeeDataForSpecificDay } from "../utils/api";


import '../css/employee-portal.css';




  interface EmployeeProps {
    name: string;
    id: number;
    signIns: EventData[];
    teamId: number;
    type:string;
  }



const ManagerView = () => {
    const nav = useNavigate();
    const [employees, setEmployees] = React.useState<EmployeeProps[]>([]);
      const [loading, setLoading] = React.useState(true);
      const [activeTab, setActiveTab] = React.useState("My Team");
      const [searchQuery, setSearchQuery] = React.useState("");
      const [notifications, setNotifications] = React.useState<any>([]);
      const [notificationCount, setNotificationCount] = React.useState(0);
      const [showNotifications, setShowNotifications] = React.useState(false);
      const [showSettings, setShowSettings] = React.useState(false);
      const [allEmployees, setAllEmployees] = React.useState<EmployeeProps[]>([]);
      
      // Settings state
      const [settings, setSettings] = React.useState({
        enableEmailNotifications: true,
        enablePushNotifications: true,
        notifyOnSignOut: true,
        notifyOnSignIn: true,
        notifyOnlyMyTeam: true
      });
      
      // Team filter
      const [activeTeam, setActiveTeam] = React.useState(1); // Default to team 1
      
     
      const filteredEmployees =  useMemo(() => {
        if (activeTab === "My Team") {
          return employees.filter((employee) => {
            return employee.name.toLowerCase().includes(searchQuery.toLowerCase());
          });
        } else {
          return allEmployees.filter((employee) => {
            return employee.name.toLowerCase().includes(searchQuery.toLowerCase());
          });
        }
      }, [activeTab, searchQuery, employees, allEmployees]);
      
      

      
      // Count employees by team
      const counts = {
        "All": allEmployees.length,
        "My Team": employees.length
      };
      
      // Handle reading all notifications
      const handleClearNotifications = () => {
        const updatedNotifications = notifications.map((notif: any ) => ({
          ...notif,
          read: true
        }));
        
        setNotifications(updatedNotifications);
        setNotificationCount(0);
      };
      
      // Handle reading a single notification
      const handleReadNotification = (id:any) => {
        const updatedNotifications = notifications.map((notif:any) => {
          if (notif.id === id && !notif.read) {
            setNotificationCount(prev => prev - 1);
            return { ...notif, read: true };
          }
          return notif;
        });
        
        setNotifications(updatedNotifications);
      };
      
      // Handle settings changes
      const handleSettingChange = (setting:string , value:any) => {
        setSettings(prev => ({
          ...prev,
          [setting]: value
        }));
      };
      

      
      // Close notifications when clicking outside
      const handleOverlayClick = () => {
        setShowNotifications(false);
      };

      useEffect(() => {
        const fetchEmployees = async () => {
          try {
            const employees = await getEmployeesForManager('Scott Lauzon');
            const signIns = await getSignInsForManagerOnDate(employees, new Date());
            const allSignIns = await fetchEmployeeDataForSpecificDay(new Date());
            setAllEmployees(allSignIns);
            setEmployees(signIns);
          } catch (error) {
            console.error("Error fetching employees:", error);
          } finally {
            setLoading(false);
          }
        };
        
        fetchEmployees();
      } , []);
      
      return (
        <div className="app-container">
          {/* Header */}
          <header className="dashboard-header">
            <div className="header-logo">
              <button onClick={() => nav('/')} className="home-link" style={{ borderColor: "transparent" }}>
                Home
              </button>
              Magni Team Status
            </div>
            
            <div className="date-display">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V8H19V19ZM19 6H5V5H19V6ZM12 10V15H17V10H12Z" fill="currentColor"/>
              </svg>
              {formatDate(new Date())}
            </div>
            
            <div className="header-actions">
              <button 
                className="action-button notification-badge"
                onClick={() => setShowNotifications(!showNotifications)}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.9 22 12 22ZM18 16V11C18 7.93 16.36 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.63 5.36 6 7.92 6 11V16L4 18V19H20V18L18 16Z" fill="currentColor"/>
                </svg>
                {notificationCount > 0 && (
                  <span className="badge">{notificationCount}</span>
                )}
              </button>
              
              <button 
                className="action-button"
                onClick={() => setShowSettings(true)}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19.14 12.94C19.18 12.64 19.2 12.33 19.2 12C19.2 11.68 19.18 11.36 19.13 11.06L21.16 9.48C21.34 9.34 21.39 9.07 21.28 8.87L19.36 5.55C19.24 5.33 18.99 5.26 18.77 5.33L16.38 6.29C15.88 5.91 15.35 5.59 14.76 5.35L14.4 2.81C14.36 2.57 14.16 2.4 13.92 2.4H10.08C9.84 2.4 9.65 2.57 9.61 2.81L9.25 5.35C8.66 5.59 8.12 5.92 7.63 6.29L5.24 5.33C5.02 5.25 4.77 5.33 4.65 5.55L2.74 8.87C2.62 9.08 2.66 9.34 2.86 9.48L4.89 11.06C4.84 11.36 4.8 11.69 4.8 12C4.8 12.31 4.82 12.64 4.87 12.94L2.84 14.52C2.66 14.66 2.61 14.93 2.72 15.13L4.64 18.45C4.76 18.67 5.01 18.74 5.23 18.67L7.62 17.71C8.12 18.09 8.65 18.41 9.24 18.65L9.6 21.19C9.65 21.43 9.84 21.6 10.08 21.6H13.92C14.16 21.6 14.36 21.43 14.39 21.19L14.75 18.65C15.34 18.41 15.88 18.09 16.37 17.71L18.76 18.67C18.98 18.75 19.23 18.67 19.35 18.45L21.27 15.13C21.39 14.91 21.34 14.66 21.15 14.52L19.14 12.94ZM12 15.6C10.02 15.6 8.4 13.98 8.4 12C8.4 10.02 10.02 8.4 12 8.4C13.98 8.4 15.6 10.02 15.6 12C15.6 13.98 13.98 15.6 12 15.6Z" fill="currentColor"/>
                </svg>
                Settings
              </button>
            </div>
          </header>
          
          {/* Filter Tabs */}
          <div className="filter-tabs">
            <button 
              className={`filter-tab ${activeTab === "My Team" ? "active" : ""}`}
              onClick={() => setActiveTab("My Team")}
            >
              My Team<span className="tab-count">{counts["My Team"]}</span>
            </button>
            <button 
              className={`filter-tab ${activeTab === "All" ? "active" : ""}`}
              onClick={() => setActiveTab("All")}
            >
              All Employees<span className="tab-count">{counts["All"]}</span>
            </button>
          </div>
          
          {/* Search Bar */}
          <div className="search-container">
            <div className="search-icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z" fill="currentColor"/>
              </svg>
            </div>
            <input 
              type="text" 
              className="search-input" 
              placeholder="Search by name..." 
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
            />
          </div>
          
          {/* Employee List */}
          <div className="employee-list" style={{ 
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            width: '100%',
            maxWidth: '600px',
            margin: '0 auto 40px', // Added bottom margin for spacing
            padding: '0 0 20px',
            height: 'auto',
            minHeight: 'auto',
            position: 'relative',
            overflowY: 'visible',
            flex: 0, // Don't flex this container
          }}>
            {loading ? (
                <div className="loading-spinner">
                <div className="spinner"></div>
                </div>
            ) : (activeTab === "My Team" && employees.length === 0) ? (
                <div className="no-results">
                <div className="no-results-icon">🔍</div>
                <p>No signouts for your team today!</p>
                </div>
            ) : (activeTab === "All" && allEmployees.length === 0) ? (
                <div className="no-results">
                <div className="no-results-icon">🔍</div>
                <p>No employees signed out!</p>
                </div>
            ) : (filteredEmployees.map((employee, index) => (
              <div key={employee.id} style={{ width: '100%' }}>
                <EmployeeCardManagerView 
                    employee={employee}
                    colorIndex={index % COLOR_PALETTE.length}
                />
              </div>
            )))}
          </div>
          {/* Notification Overlay */}
          <div 
            className={`notification-overlay ${showNotifications ? "open" : ""}`}
            onClick={handleOverlayClick}
          ></div>
          
          {/* Notification Center */}
          <NotificationCenter 
            notifications={notifications}
            isOpen={showNotifications}
            onClose={() => setShowNotifications(false)}
            onClearAll={handleClearNotifications}
            onReadNotification={handleReadNotification}
          />
          
          {/* Settings Overlay */}
          <div 
            className={`settings-overlay ${showSettings ? "open" : ""}`}
            onClick={() => setShowSettings(false)}
          >
            <div className="settings-modal" onClick={e => e.stopPropagation()}>
              <div className="settings-header">
                <h3 className="settings-title">Notification Settings</h3>
                <button 
                  className="settings-close"
                  onClick={() => setShowSettings(false)}
                >
                  &times;
                </button>
              </div>
              
              <div className="settings-content">
                <div className="settings-section">
                  <h4 className="settings-section-title">General Notifications</h4>
                  
                  <div className="settings-option">
                    <span className="option-label">Email Notifications</span>
                    <label className="toggle-switch">
                      <input 
                        type="checkbox" 
                        checked={settings.enableEmailNotifications}
                        onChange={() => handleSettingChange('enableEmailNotifications', !settings.enableEmailNotifications)}
                      />
                      <span className="toggle-slider"></span>
                    </label>
                  </div>
                  
                  <div className="settings-option">
                    <span className="option-label">Push Notifications</span>
                    <label className="toggle-switch">
                      <input 
                        type="checkbox" 
                        checked={settings.enablePushNotifications}
                        onChange={() => handleSettingChange('enablePushNotifications', !settings.enablePushNotifications)}
                      />
                      <span className="toggle-slider"></span>
                    </label>
                  </div>
                </div>
                
                <div className="settings-section">
                  <h4 className="settings-section-title">Notification Types</h4>
                  
                  <div className="settings-option">
                    <span className="option-label">Employee Sign-Outs</span>
                    <label className="toggle-switch">
                      <input 
                        type="checkbox" 
                        checked={settings.notifyOnSignOut}
                        onChange={() => handleSettingChange('notifyOnSignOut', !settings.notifyOnSignOut)}
                      />
                      <span className="toggle-slider"></span>
                    </label>
                  </div>
                  
                  <div className="settings-option">
                    <span className="option-label">Employee Sign-Ins</span>
                    <label className="toggle-switch">
                      <input 
                        type="checkbox" 
                        checked={settings.notifyOnSignIn}
                        onChange={() => handleSettingChange('notifyOnSignIn', !settings.notifyOnSignIn)}
                      />
                      <span className="toggle-slider"></span>
                    </label>
                  </div>
                  
                  <div className="settings-option">
                    <span className="option-label">Only My Team</span>
                    <label className="toggle-switch">
                      <input 
                        type="checkbox" 
                        checked={settings.notifyOnlyMyTeam}
                        onChange={() => handleSettingChange('notifyOnlyMyTeam', !settings.notifyOnlyMyTeam)}
                      />
                      <span className="toggle-slider"></span>
                    </label>
                  </div>
                </div>
              </div>
              
              <div className="settings-footer">
                <button 
                  className="settings-save"
                  onClick={() => setShowSettings(false)}
                >
                  Save Settings
                </button>
              </div>
            </div>
          </div>
        </div>
      );


}

export default ManagerView;